import React from 'react';

const commonZones = ['Africa/Johannesburg', 'UTC', 'Europe/London', 'America/New_York', 'Asia/Kolkata'];
const supported = (Intl as typeof Intl & { supportedValuesOf?: (key: string) => string[] }).supportedValuesOf;
const zones = Array.from(new Set([...commonZones, ...(supported ? supported('timeZone') : [])])).sort();

export function validPricingTimeZone(value: string): boolean {
  if (!value) return true; // Unset is allowed in an incomplete draft.
  try { new Intl.DateTimeFormat('en', { timeZone: value }); return true; }
  catch { return false; }
}

export default function PricingTimeZoneField({ value, onChange }: { value: string; onChange: (value: string) => void }) {
  const valid = validPricingTimeZone(value);
  const query = value.toLowerCase().replace(/ /g, '_');
  const suggestions = value ? zones.filter(zone => zone.toLowerCase().includes(query)).slice(0, 3) : commonZones.slice(0, 3);
  const warning = 'Choose a recognised time zone, for example Africa/Johannesburg, or leave it blank.';
  return <div className="col-md-6">
    <label htmlFor="pricing-zone">Time zone</label>
    <input id="pricing-zone" className="form-control" type="text" list="pricing-zone-options" autoComplete="off"
      value={value} onChange={e => onChange(e.target.value)} aria-invalid={!valid}
      aria-describedby="pricing-zone-help"
      ref={input => input?.setCustomValidity(valid ? '' : warning)} />
    <datalist id="pricing-zone-options">{suggestions.map(zone => <option key={zone} value={zone} />)}</datalist>
    <p id="pricing-zone-help" className={valid ? 'small text-muted' : 'small text-danger'}>
      {valid ? 'Type a city or region and choose a suggestion. Up to three matches are shown.' : warning}
    </p>
  </div>;
}
